import React from 'react';
import _ from 'lodash';

window.React = React;
window._ = _;
